import { callNative } from '@ifit/native-webview-interface';
import IFitButton from '@ifit/react-components/dist/Button';
import { useDeviceType } from '../../state-management/selectors/use-device-type';
import { isClub } from '../../util/is-club';
import { isMatrix } from '../../util/is-matrix';
import { useSoftwareNumber } from '../../state-management/selectors/use-software-number';
import { Text } from './text';
import './index.scss';

export default function ManualWorkout(): JSX.Element {
  const softwareNumber = useSoftwareNumber();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'mobile';

  const startManualWorkout = (): void => {
    callNative({ methodName: 'StartManualWorkout' });
  };

  if (isMobile) {
    return (
      <IFitButton className="manual-workout" onClick={startManualWorkout}>
        {Text.manualStart}
      </IFitButton>
    );
  }

  if (isClub(softwareNumber) && isMatrix(softwareNumber)) {
    return (
      <div className="matrix-club-manual-workout">
        <h2 className="matrix-club-manual-workout-heading">{Text.manualWorkout}</h2>
        <p className="matrix-club-manual-workout-description">{Text.manualWorkoutDescription}</p>
        <IFitButton className="matrix-club-manual-workout-button" onClick={startManualWorkout}>
          {Text.manualWorkoutButton}
        </IFitButton>
      </div>
    );
  }

  return null;
}
